<h1 class="page-header"><i class="fa fa-wrench" aria-hidden="true"></i> ADMIN SETTINGS</h1>

<div class="container-fluid">

<nav class="col-sm-2">
  <ul class="nav nav-pills nav-stacked">
    <li><a (click)="showEmail()">SMTP Email Account</a></li>
    <li><a (click)="showPassword()">Password Policy</a></li>
    <li><a (click)="showSession()">Session Policy</a></li>
    <li><a (click)="showUser()">User Lockout</a></li>
    <li><a (click)="showLicensing()">Licensing</a></li>
    <li><a (click)="showLocate()">Map Settings</a></li>
  </ul>
</nav>

  <div class="row">
    <app-settings-email [emailAccount]="emailAccount"></app-settings-email>
    <app-settings-password [passwordPolicy]="passwordPolicy"></app-settings-password>
    <app-settings-session [session]="session"></app-settings-session>
    <app-settings-user [userLockout]="userLockout"></app-settings-user>
    <app-settings-licensing [serverObjectInstance]="licensingServerObjectInstance" [license_email_address]="licensingEmail" [license_email_days]="licensingDays"></app-settings-licensing>
    <app-settings-mapping [mapping]="mapping"></app-settings-mapping>
    <div class="col-sm-1">&nbsp;</div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
